import { TENANT_ROLE_LABELS, TENANT_ROLES, type TenantRole } from '@lib/enums/tenant-role.enum'
import type { BadgeTone } from '@/components/ui/badge'

export const ROLE_LABELS = TENANT_ROLE_LABELS

export const ROLE_DESCRIPTIONS: Record<TenantRole, string> = {
  owner: 'Everything, including the team and live API keys',
  developer: 'Integration settings, test keys, logs, and envelopes',
  viewer: 'Read-only envelopes and logs',
}

/** Owners stand out; the other roles stay neutral. */
export const ROLE_TONES: Record<TenantRole, BadgeTone> = {
  owner: 'accent',
  developer: 'neutral',
  viewer: 'neutral',
}

export const ROLE_OPTIONS = TENANT_ROLES
